import React from "react";
import get from "lodash/get";
import { useField, useFormikContext } from "formik";
import TextareaAutosize from "react-textarea-autosize";
import { AUTO_ATTRS } from "components/Form/fields/constants";
import { INPUT_CLASSES } from "utils/constants/ui";

const Textarea = ({ name, ...remainder }) => {
  const { setFieldValue, setFieldTouched, touched } = useFormikContext();
  const fieldTouched = get(touched, name);
  const [field] = useField(name);
  const { value } = field;

  const taProps = {
    className: INPUT_CLASSES,
    minRows: 3,
    disabled: false,
    value: value || "",
    ...AUTO_ATTRS,
    onChange: (evt) => {
      const newVal = evt.target.value;
      setFieldValue(name, newVal);
      if (!fieldTouched) {
        setTimeout(() => setFieldTouched(name, true));
      }
    },
    onBlur: () => {
      setFieldTouched(name, true);
    },
    ...remainder
  };

  return (
    <div className="w-100">
      <TextareaAutosize {...taProps} />
    </div>
  );
};

Textarea.propTypes = {};

Textarea.defaultProps = {};

export default Textarea;
